/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useContext } from "react";

import { bem } from "../../../shared/BEM";
import { renderFormElementList } from "./renderFormElement";
import { FormRow } from "../../../shared/FormModel/elements/FormRow";
import { useFormElement } from "../../../shared/hooks/useFormElement";
import { ConfigContext } from "../../ConfigContext";

/**
 * Component props
 */
export interface IFormRowComponentProps {
	element: FormRow
}

export function FormRowComponent(props: IFormRowComponentProps) {

	const configCtx = useContext(ConfigContext);
	const state = useFormElement(props.element);

	if (!state.display) {
		return null;
	}

	if (configCtx.mode === "ssr" && state.config.print === false) {
		return null;
	}

	const mods = [
		"clr-scheme-" + (state.config.colorSchema || "default")
	];

	const stl = bem("form-row", null, mods);

	return <div className={stl.str}>
		{renderFormElementList(state.content)}
	</div>;

}